import { render } from "./PendingPaymentBanner.vue?vue&type=template&id=5f69a985&scoped=true"
import script from "./PendingPaymentBanner.vue?vue&type=script&lang=js"
export * from "./PendingPaymentBanner.vue?vue&type=script&lang=js"

import "./PendingPaymentBanner.vue?vue&type=style&index=0&id=5f69a985&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f69a985"]])

export default __exports__